import type { FC } from 'react';
import type { EvalResolutionCheck } from '@queries/evalRuns';

import { GuidanceHero } from './GuidanceHero';

interface RecheckProgressProps {
  /** The in-flight check (the detail response sorts newest first). */
  check: EvalResolutionCheck;
}

/**
 * The drawer body while the AI re-check runs — the same takeover the first
 * scan gets, so the list underneath is not seen shifting as verdicts land.
 */
export const RecheckProgress: FC<RecheckProgressProps> = ({ check }) => {
  const total = check.total_findings ?? 0;
  const assessed = Math.min(check.assessed_findings ?? 0, total);
  const pct = total > 0 ? Math.round((assessed / total) * 100) : 0;

  return (
    <div data-testid="pbqa-recheck-progress">
      <GuidanceHero title="Re-scanning your contract">
        Checking your edited contract against the remaining open suggestions.
        <br />
        <br />
        Each one gets a short review with reasoning, any that have been addressed will be resolved for you, and the rest
        stay open.
      </GuidanceHero>
      <div className="px-6 pb-6">
        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-600" data-testid="pbqa-recheck-progress-label">
            {assessed} of {total} suggestions re-scanned
          </span>
          <span className="font-semibold text-gray-900 tabular-nums">{pct}%</span>
        </div>
        <div className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-gray-200">
          <div className="h-full rounded-full bg-violet-600 transition-all" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
};
